/**
 * Active-organization helpers that work OUTSIDE React (so SSE clients,
 * fetch shims, and one-shot utilities can all stamp the `X-Org-Id` header
 * without pulling a hook). The React-facing state still lives in
 * `auth-provider.tsx`; this module is the thin persisted mirror.
 *
 * Storage contract:
 *   localStorage['jam:activeOrgId'] = '<orgId>' | absent
 */

const STORAGE_KEY = 'jam:activeOrgId';

export function readActiveOrgId(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function writeActiveOrgId(orgId: string | null): void {
  if (typeof window === 'undefined') return;
  try {
    if (orgId) {
      window.localStorage.setItem(STORAGE_KEY, orgId);
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Private mode / quota errors — the server falls back to the user's
    // primary org, so a missing header is recoverable.
  }
}
